<template>
  <div class="maxbox">
    <div>
      <div class="top">
        <p>我的资产</p>
      </div>
      <div class="main">
        <button @click="goback" class="return"><img src="@/assets/images/left-arrow.png" alt="返回"></button>
        <div class="main-content">
          <h2>奖金明细</h2><br>
          <!-- 修改：将内联样式提取为class，方便统一控制 -->
          <div class="table-container">
            <table class="bonus-table">
              <tbody>
                <tr>
                  <td>社区互助金额：</td>
                  <td>{{ referralRewards }} USDT</td>
                </tr>
                <tr>
                  <td>社区升级金额：</td>
                  <td>{{ upgradeRewards }} USDT</td>
                </tr>
                <tr>
                  <td class="total-label">获得互助总额：</td>
                  <td class="total-value">{{ totalRewards }} USDT</td>
                </tr>
              </tbody>
            </table>
          </div>
          <br>
          <button @click="claimFC" class="claim-fc-button">领取CYC币</button>

          <div class="itemheader">
            <img src="@/assets/images/ban-2.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 脚本部分保持不变，此处省略（和原代码一致）
import { ethers } from 'ethers';
import { contractAddress, contractABI } from '@/js/contract.js';

export default {
  name: 'income',
  data() {
    return {
      referralRewards: '加载中...',
      upgradeRewards: '加载中...',
      totalRewards: '加载中...',
    }
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    async connectWallet() {
      if (window.ethereum) {
        try {
          await window.ethereum.request({ method: 'eth_requestAccounts' });
          return new ethers.providers.Web3Provider(window.ethereum);
        } catch (error) {
          console.error("用户拒绝了账户访问请求", error);
        }
      } else {
        console.error("未检测到Ethereum提供商。请安装MetaMask。");
      }
    },
    async getUserBonuses() {
      try {
        const provider = await this.connectWallet();
        if (!provider) return;

        const signer = provider.getSigner();
        const contract = new ethers.Contract(contractAddress, contractABI, signer);
        const userAddress = await signer.getAddress();

        if (!userAddress) {
          alert("无法检测到用户地址，请先连接到MetaMask。");
          return;
        }

        const [totalRewards, referralRewards, upgradeRewards] = await Promise.all([
          contract.viewTotalRewards(),
          contract.referralRewards(userAddress),
          contract.upgradeRewards(userAddress)
        ]);

        const formatUSDT = (value) => ethers.utils.formatUnits(value, 18);

        this.totalRewards = formatUSDT(totalRewards);
        this.referralRewards = formatUSDT(referralRewards);
        this.upgradeRewards = formatUSDT(upgradeRewards);

      } catch (error) {
        console.error("查询奖金失败", error);
        alert("查询失败，请确保已连接到MetaMask并检查网络。");
      }
    },
    async withdrawBonuses() {
      try {
        const provider = await this.connectWallet();
        if (!provider) return;

        const signer = provider.getSigner();
        const contract = new ethers.Contract(contractAddress, contractABI, signer);
        const withdrawTx = await contract.withdraw();
        await withdrawTx.wait();
        alert("提取成功！");
        this.getUserBonuses();  // 更新显示信息
      } catch (error) {
        console.error("提取失败", error);
        alert("提取失败，错误详情见控制台。");
      }
    },
    claimFC() { // 添加领取FC币的方法
      this.$router.push('/claim-fc');
    }
  },
  mounted() {
    this.getUserBonuses();
  }
}
</script>

<style scoped>
@import "@/assets/css/style.css";
@import "@/assets/css/detill.css";

.main {
  padding-top: 50px;
}

.main-content {
  text-align: center;
  /* 修改：移除固定高度，让内容自适应 */
  border: 2px solid white;

}

.claim-fc-button {
  display: block;
  margin: 10px auto;
  padding: 5px 15px;
  background-color: #429dff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  width: 80%;
}

.claim-fc-button:hover {
  background-color: #218838;
}

/* 新增：表格容器样式 */
.table-container {
  width: 90%;
  margin: 0 auto;

}

/* 新增：表格核心样式（包含高度控制） */
.bonus-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid gray;
  /* 关键：设置表格高度，可根据需求修改（如200px、300px） */
  height: 150px;
  /* 让表格内容垂直居中 */
  table-layout: fixed;

}

/* 表格单元格样式 */
.bonus-table td {
  padding: 10px;
  font-size: 14px;
  border-bottom: 1px solid gray;

}

/* 左侧单元格居左 */
.bonus-table td:first-child {
  text-align: left;
}

/* 右侧单元格居右 */
.bonus-table td:last-child {
  text-align: right;
}

/* 总额标签样式 */
.total-label {
  font-weight: bold;
}

/* 总额数值样式 */
.total-value {
  font-weight: bold;
  color: red;
}

/* 最后一行移除下边框 */
.bonus-table tr:last-child td {
  border-bottom: none;
}
</style>
